
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/component-inherit/index.js
// module id = 88
// module chunks = 0